/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Helper integrado a menú de acciones
*      3       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Atajo F4 estandar para dashboard
* --------------------------------------------------------------------------------------- */

import { AppBar, Drawer, Hidden, IconButton, Toolbar, Tooltip, Typography, Breadcrumbs, Box, Grid } from "@mui/material";
import { Fragment, useState } from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import SizeSoftXBody from "./SizeSoftXBody";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { useLayout } from "../../context/System/LayoutContext";
import SizeSoftXHelpFloatButton from "../helpconfig/SizeSoftXHelpFloatButton";
import { useDashboardF4Shortcut } from "../../hooks/useDashboardF4Shortcut";

export default function SizeSoftXVentasLayout({
    children,
    titlePage,
    buttonActions,
    buttonsPosition,
    detailComponent,
    hideBreadcrumbs,
    breadCrumbsComponent,
}) {
    const [detailOpen, setDetailOpen] = useState(false);
    const { detailDashboardOpen, handleOpenDetailDashboard, handleCloseDetailDashboard } = useLayout();
    useDashboardF4Shortcut();

    const handleOpenDetail = () => {
        setDetailOpen(true);
    };

    const handleCloseDetail = () => {
        setDetailOpen(false);
    };

    return (
        <Fragment>
            <div className="sizesoftx-elementos">
                <div className="work">
                    <SizeSoftXBody>
                        <AppBar
                            className="title"
                            position="sticky"
                            color="secondary"
                            style={{ zIndex: 100, overflowX: "auto" }}
                        >
                            <Toolbar variant="dense" style={{ gap: 4 }}>
                                <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                    {titlePage}
                                </Typography>
                                {buttonActions}
                                <Hidden mdUp>
                                    {detailComponent && (
                                        <Tooltip title="Ver detalles">
                                            <IconButton onClick={handleOpenDetail}>
                                                <ReadMoreIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Hidden>
                                <Hidden mdDown>
                                    {detailComponent && !detailDashboardOpen && (
                                        <Tooltip title="Mostrar panel de detalle">
                                            <IconButton onClick={handleOpenDetailDashboard}>
                                                <ReadMoreIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Hidden>
                                <SizeSoftXHelpFloatButton variant="menu" />
                            </Toolbar>
                        </AppBar>
                        <div className="elements">
                            <SizeSoftXBody>{children}</SizeSoftXBody>
                        </div>
                    </SizeSoftXBody>
                </div>
            </div>
        </Fragment>
    );
}
